import './Footer.scss';
import React from 'react';


class Footer extends React.Component {
  render() {
    return (
      <div className="Footer">
        <div className="top" />
        <div className="content">
          &copy; 2020 Axle Medical
        </div>
      </div>
    );
  }
}

export default Footer;

